<div>
  <input type="text" pInputText class="p-inputtext-sm"  [(ngModel)]="value" (ngModelChange)="onChange($event)"
  [attr.maxlength]="maxlength" (focus)="focus($event)" (blur)="blur($event)"/>
  <span *ngIf="changeText && value?.length" style="float:right;"> {{value?.length}}/ {{maxlength}} </span>
</div>
